import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./plugins/axios";
import "@/global-components";
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
